<div>
    <!-- Header -->
    <div class="flex justify-between border-b border-b-gray-300 zuper-dialog-header">
      <h6 class="font-bold text-2xl primary-font">{{'text.select.folder' | translate}}</h6>
      <div class="flex items-center mr-1">
        <span (click)="closeModal()" class="rounded-full cursor-pointer flex justify-center items-center hover:bg-gray-200 h-10 w-10 p-2 ml-2" >
          <em class="ti ti-x text-xl font-bold mt-0.5"></em>
        </span>
      </div>
    </div>
 
    <!--body-->
    <div *ngIf="folders?.length">
    <div class="p-4 grid grid-cols-3 space-x-3 folder-container bg-gray-50 zuper-scrollbar cursor-pointer" [ngClass]="{'p-5': folders?.length === 1}" style="max-height:calc(80vh - 11rem) !important;overflow: auto;">
      <div class="folder" (click)="highlightFolder(folder)"
      [ngClass]="{ 'highlighted':folder?.folder_uid ? folder?.folder_uid === selectedFolder?.folder_uid : folder?.key === selectedFolder?.key}" *ngFor="let folder of folders">
        <div class="folder-name self-start font-bold text-xl truncate" title="{{ folder?.folder_name  }}">{{ folder?.folder_name }}</div>
        <div class="text-base ml-1 text-gray-500 self-start">{{folder?.report_count}} Reports</div>

        <div class="tick-mark" *ngIf="folder?.folder_uid === selectedFolder?.folder_uid">
          <svg xmlns="http://www.w3.org/2000/svg" width="30" height="30" viewBox="0 0 24 24" fill="currentColor" class="icon icon-tabler icons-tabler-filled icon-tabler-circle-check text-green-600 shake-animation">
            <path stroke="none" d="M0 0h24v24H0z" fill="none" />
            <path d="M17 3.34a10 10 0 1 1 -14.995 8.984l-.005 -.324l.005 -.324a10 10 0 0 1 14.995 -8.336zm-1.293 5.953a1 1 0 0 0 -1.32 -.083l-.094 .083l-3.293 3.292l-1.293 -1.292l-.094 -.083a1 1 0 0 0 -1.403 1.403l.083 .094l2 2l.094 .083a1 1 0 0 0 1.226 0l.094 -.083l4 -4l.083 -.094a1 1 0 0 0 -.083 -1.32z" />
          </svg>
        </div>
      </div>
    </div>
    <div mat-dialog-actions class="flex space-x-3 border-t border-gray-300 zuper-dialog-footer" [ngClass]="{'justify-between': folders?.length <= 10,'justify-end': folders?.length > 10}">
        <button (click)="openNewFolder()" *ngIf="folders?.length <= 10"
           class="px-4 flex items-center space-x-1 py-2 border b-1 border-gray-300 shadow-sm text-base font-medium rounded-md text-gray-600 bg-white btn-small hover:bg-gray-50" type="button">
           <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1" stroke-linecap="round" stroke-linejoin="round" class="icon icon-tabler icons-tabler-outline icon-tabler-folder-plus">
            <path stroke="none" d="M0 0h24v24H0z" fill="none" />
            <path d="M12 19h-7a2 2 0 0 1 -2 -2v-11a2 2 0 0 1 2 -2h4l3 3h7a2 2 0 0 1 2 2v3.5" />
            <path d="M16 19h6" />
            <path d="M19 16v6" />
          </svg>
          <span class="flex item-center mt-1">
            {{'text.create.folder' | translate}}
          </span>
        </button>
        <div>

          <button (click)="onMoveFolder()" [disabled]="!selectedFolder?.folder_uid || isMoveDisabled()" [ngClass]="{'disabled-move-folder-btn': !selectedFolder?.folder_uid || isMoveDisabled()}"
             class="bg-primary px-6 flex items-center space-x-1 py-2 border b-1 border-gray-300 shadow-sm text-white font-medium rounded-md text-white-600 btn-small" type="submit">
             <span class="flex item-center">
              {{'text.move' | translate}}
             </span>
          </button>
        </div>
    </div>
    </div>
    <div *ngIf="!folders?.length" class="flex items-center justify-center h-full" style="min-height: 400px;width: 35vw !important;">
      <div class="flex flex-col items-center justify-center primary-font">
      <img class="w-56 h-40" src="assets/images/svgs/no_folder_found.svg"
      alt="No Data found">
      <h4 class="text-lg text-gray-500 font-semibold">{{'text.no.folders.created' | translate}}</h4>
      <p class="text-base text-gray-400 mt-1">{{'text.organize.folders' | translate}}</p>
      <a (click)="openNewFolder()" mat-stroked-button class="btn-primary inline-flex items-center px-4 py-3 h-9 shadow-xs text-base font-medium rounded-md text-gray-700 bg-white cursor-pointer mt-4">
        <em class="text-xl ti ti-plus"></em><span class="ml-2 primary-font text-base mt-0.5">{{'text.create.new.folder' | translate}}</span>
      </a>
    </div>
    </div>
  </div>